import axios from 'axios'

// No configuramos baseURL, usamos URLs relativas
// En producción (Render): frontend y backend en el mismo dominio
// En desarrollo: Vite proxy maneja /api/* → http://localhost:5020

// Configurar axios para incluir el token JWT en todas las peticiones
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para manejar errores 401 (no autorizado)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si es un error 401, limpiar el token y redirigir a login
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user')
      window.location.href = '/'
    }
    
    return Promise.reject(error)
  }
)

export default axios
